// API functions for ADU Lab
import apiClient from './services/api-client';

// Process assessment (for Tier 1 assessments)
export const processAssessment = async (assessmentData, requestOptions) => {
  try {
    const data = await apiClient.processAssessment(assessmentData, requestOptions);
    return data;
  } catch (error) {
    console.error('Error processing assessment:', error);
    throw error;
  }
};

// Create Stripe checkout session
export const createCheckoutSession = async (checkoutData) => {
  try {
    const data = await apiClient.createCheckoutSession(checkoutData);
    return data;
  } catch (error) {
    console.error('Error creating checkout session:', error);
    throw error;
  }
};

// Handle Stripe webhooks (called from server-side)
export const handleStripeWebhook = async (webhookData) => {
  try {
    const data = await apiClient.handleStripeWebhook(webhookData);
    return data;
  } catch (error) {
    console.error('Error handling webhook:', error);
    throw error;
  }
};

// Additional API functions that can be added as needed:

// Get checkout session details
export const getCheckoutSession = async (sessionId) => {
  try {
    const data = await apiClient.getCheckoutSession(sessionId);
    return data;
  } catch (error) {
    console.error('Error getting checkout session:', error);
    throw error;
  }
};

// Claim assessment
export const claimAssessment = async (claimData) => {
  try {
    const data = await apiClient.claimAssessment(claimData);
    return data;
  } catch (error) {
    console.error('Error claiming assessment:', error);
    throw error;
  }
};

// Create portal session
export const createPortalSession = async (customerId) => {
  try {
    const data = await apiClient.createPortalSession({ customerId });
    return data;
  } catch (error) {
    console.error('Error creating portal session:', error);
    throw error;
  }
};

// Get subscription status
export const getSubscriptionStatus = async (userId) => {
  try {
    const data = await apiClient.getSubscriptionStatus(userId);
    return data;
  } catch (error) {
    console.error('Error getting subscription status:', error);
    throw error;
  }
};
